module.exports = __webpack_public_path__ + "ic-connectivity.svg?db76eb0f840973419fbb84f1fdd6fc5c";